module.exports = __webpack_public_path__ + "static/media/calf@2x.ea351341.jpg";